import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const contactDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$contactId`,
    component: lazyRouteComponent(() => import('./ContactDetails'))
  })
